// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "claire_failure_group".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { claireFailureGroupStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "claire_failure_group" table (1:1 with a DB row, on the wire). */
export const claireFailureGroupAtomSchema = z.object({
    id: z.string(),
    title: z.string(),
    description: z.string(),
    failureType: z.string().nullable(),
    status: z.enum(claireFailureGroupStatusValues),
    linearUrl: z.string().nullable(),
    fixPrUrl: z.string().nullable(),
    reopenedAt: z.string().datetime().nullable(),
    closedAt: z.string().datetime().nullable(),
    createdByUserId: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=claireFailureGroup.js.map